/* eslint-disable no-underscore-dangle */

export const contentfulArrayToObject = (
  array = [],
  propertyName = '__typename',
) =>
  array.reduce((obj, item) => {
    const existingItem = obj[item[propertyName]]
    // This is to check if the object already exists.
    // If it does, push the new item as an array
    // Else, just put the item inside the object
    let newItem = item
    if (existingItem) {
      if (existingItem.length) newItem = [...existingItem, item]
      else newItem = [existingItem, item]
    }
    return {
      ...obj,
      [item[propertyName]]: newItem,
    }
  }, {})

export const filterItemByPropertyName = ({
  arrayToFilter,
  propertyName = '__typename',
  propertyValue,
}) => arrayToFilter.filter((item) => item[propertyName] === propertyValue)

export const getDescription = (raw) => {
  if (!raw) {
    return ''
  }
  const rawDescription = JSON.parse(raw)
  return rawDescription?.content[0].content[0].value
}

export const replaceBucketUrl = (url = '') =>
  url.replace(
    /https:\/\/objectstorage\.me-jeddah-1\.oraclecloud\.com\/n\/axvznyqdan5v\/b\/(website-assets|UAT-website-bucket)\/o\//,
    '/assets/',
  )
